// extracted by mini-css-extract-plugin
export var categoryBtn = "project-category-list-module--category-btn--Sw3J4";
export var flexContainer = "project-category-list-module--flex-container--HN0Nk";
export var projectCategoryList = "project-category-list-module--project-category-list--j+xVV";